import * as Api from '@ViewModels';

interface ICanEditAutomationTemplateParams {
	template: Pick<Api.IAutomationTemplateReference, 'scope' | 'status'>;
	userRole?: Api.UserRole;
	impersonationContext?: Api.IImpersonationContext;
}

export function canEditAutomationTemplate({
	template,
	userRole,
	impersonationContext,
}: ICanEditAutomationTemplateParams) {
	const isAdmin = userRole === Api.EUserRole.SuperAdmin || userRole === Api.EUserRole.Admin;
	const impersonatedUserRole = impersonationContext?.user?.role;
	const isImpersonatingAccountAdmin =
		impersonatedUserRole === Api.EUserRole.SuperAdmin || impersonatedUserRole === Api.EUserRole.Admin;

	return (
		template.status !== Api.TemplateStatus.Archived &&
		template.scope !== Api.TemplateScope.Industry &&
		(isAdmin || isImpersonatingAccountAdmin || template.scope === Api.TemplateScope.User)
	);
}
